"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logUserAction = exports.logUserActivity = exports.ActivityType = exports.logUserEvent = exports.initAmplitude = void 0;
const amplitude_js_1 = __importDefault(require("amplitude-js"));
const platform_1 = require("./platform");
const tokens_1 = require("../config/tokens");
const Sentry = __importStar(require("@sentry/browser"));
let amplitudeInitialized = false;
function initAmplitude({ email, appVersion, company }) {
    if (localStorage.getItem(tokens_1.AMPLITUDE_TOKEN) && (0, platform_1.getAPIUrl)()) {
        const apiURL = new URL((0, platform_1.getAPIUrl)());
        if (apiURL && apiURL.host) {
            amplitude_js_1.default
                .getInstance()
                .init(localStorage.getItem(tokens_1.AMPLITUDE_TOKEN) || '', localStorage.getItem(tokens_1.USERID_TOKEN) || undefined, {
                apiEndpoint: `${apiURL.host}/amplitude`,
                trackingOptions: {
                    country: false,
                    city: false,
                    ip_address: false,
                    region: false,
                },
            });
            if (email) {
                amplitude_js_1.default.getInstance().setUserProperties({ email });
            }
            if (appVersion) {
                amplitude_js_1.default.getInstance().setVersionName(appVersion);
            }
            if (company) {
                amplitude_js_1.default.getInstance().setUserProperties({
                    company_id: company.id,
                    company_name: company.name,
                });
            }
            amplitudeInitialized = true;
            console.log('Amplitude initialized');
        }
    }
}
exports.initAmplitude = initAmplitude;
function logUserEvent(eventId, props) {
    try {
        if (amplitudeInitialized)
            amplitude_js_1.default
                .getInstance()
                .logEvent((process.env.REACT_APP_PRODUCT_ID
                ? process.env.REACT_APP_PRODUCT_ID + ':'
                : '') + eventId, props);
    }
    catch (err) {
        console.error(err);
        try {
            Sentry.captureException(err);
        }
        catch (err) {
            console.error(err);
        }
    }
}
exports.logUserEvent = logUserEvent;
var ActivityType;
(function (ActivityType) {
    ActivityType["hover"] = "hover";
    ActivityType["click"] = "click";
    ActivityType["dragNDrop"] = "dragNDrop";
    ActivityType["expand"] = "expand";
    ActivityType["collapse"] = "collapse";
    ActivityType["scroll"] = "scroll";
    ActivityType["inactive"] = "inactive";
    ActivityType["reload"] = "reload";
    ActivityType["bounce"] = "bounce";
    ActivityType["indirect"] = "happened";
    ActivityType["type"] = "typed";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
function logUserActivity(activityType, element, props) {
    const eventId = activityType.toString() + ':' + element;
    logUserEvent(eventId, props);
}
exports.logUserActivity = logUserActivity;
function logUserAction({ type = ActivityType.click, eventName }, props) {
    const eventId = [eventName, type.toString()].join(':');
    logUserEvent(eventId, props);
}
exports.logUserAction = logUserAction;
